import React, { useEffect, useState } from "react";
import { Button, DatePicker, Popconfirm, Select, Table, Tooltip, Input } from "antd";
import { useNavigate } from "react-router-dom";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import "../../css/common.css";
import { post } from "../../../services/services";
import { ApiURL, dailytasklogdownloadPdfUrl } from "../../../services/apiConstants";
import { ErrorToast, SuccessToast } from "../../../widgets/AppToast";
import VoyageDetails from "../../../components/VoyageDetails";
import { formatDate } from "../../../utils/dateFormatter";
import useVoyageList from "../../../hooks/useVoyageList";
import dayjs from "dayjs";
import { dateRanges } from "../../../Data/data";
import { DOWNLOADPDF } from "../../../utils/downloadPdf";

const { RangePicker } = DatePicker;

const ListDailyShipStaffTask = () => {
  const navigate = useNavigate();
  const { voyageList } = useVoyageList();
  const [page_loader, set_page_loader] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [staff_dashboard, set_staff_dashboard] = useState([]);
  const [voyage_ids, set_voyage_id] = useState("");
  const [voyage_status, set_voyage_status] = useState(true);
  const [dates, setDates] = useState([dayjs().subtract(2, "day"), dayjs()]);
  const [startDate, endDate] = dates?.map((d) => d.format("YYYY-MM-DD"))||[];
  const [searchText, setSearchText] = useState("");

  const displayedData = filteredData?.filter((item) =>
    (item.task_details || "").toLowerCase().includes(searchText.toLowerCase()) ||
    (item.department || "").toLowerCase().includes(searchText.toLowerCase()) ||
    (item.staff_role || "").toLowerCase().includes(searchText.toLowerCase()) ||
    (item.component || "").toLowerCase().includes(searchText.toLowerCase())
  );

  useEffect(() => {
    const staff_dashboards = localStorage.getItem("staff_dashboard");
    const parsedData = JSON.parse(staff_dashboards);
    set_staff_dashboard(parsedData);
    if (voyage_ids) {
      LIST_DAILY_SHIP_STAFF_TASK_API(voyage_ids);
    }
  }, [voyage_ids]);

  useEffect(() => {
    if (voyageList?.length > 0) {
      const runningVoyage = voyageList.find((voyage) => voyage.voyage_status == true);
      set_voyage_status(runningVoyage?.voyage_status);
      if (runningVoyage) {
        set_voyage_id(runningVoyage.id);
      }
    }
  }, [voyageList]);

  const LIST_DAILY_SHIP_STAFF_TASK_API = async (voyage_id) => {
    set_page_loader(true);
    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("voyage_id", voyage_id);
      post(ApiURL.list_daily_task_report_st, FORM_DATA).then((res) => {
        if (res?.status == true) {
          setFilteredData(res.data);
        }
        set_page_loader(false);
      });
    } catch (error) {
      console.error("Error fetching Staff list:", error);
      set_page_loader(false);
    }
  };

  const onDailyShipStaffTaskRecord = (id) => {
    const FORM_DATA = new FormData();
    FORM_DATA.append("record_id", id);
    post(ApiURL.delete_daily_task_report_st, FORM_DATA).then((res) => {
      if (res?.status == true) {
        SuccessToast("Success!!", "Daily ship staff task Details Successfully deleted.");
        LIST_DAILY_SHIP_STAFF_TASK_API(voyage_ids);
      } else {
        ErrorToast("Error", "Sorry Daily ship staff task details not deleted ");
      }
    });
  };

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      align: "center",
      key: "id",
      sorter: (a, b) => a.id - b.id,
    },
    {
      title: "Staff Role",
      dataIndex: "staff_role",
      align: "center",
      key: "staff_role",
    },
    {
      title: "Task Details",
      dataIndex: "task_details",
      align: "center",
      key: "task_details",
      width: 300,
    },
    {
      title: "Department",
      dataIndex: "department",
      align: "center",
      key: "department",
    },
    {
      title: "Component",
      dataIndex: "component",
      align: "center",
      key: "component",
    },
    {
      title: "Remark By Staff Role",
      dataIndex: "staff_role",
      align: "center",
      key: "staff_role",
    },
    {
      title: "Created Date",
      dataIndex: "created_at",
      align: "center",
      key: "created_at",
      render: (text, record) => formatDate(record?.created_at),
    },
    {
      title: "Updated Date",
      dataIndex: "updated_at",
      align: "center",
      key: "updated_at",
      render: (text, record) => formatDate(record?.updated_at),
    },
    {
      title: "Action",
      align: "center",
      key: "Action",
      render: (text, record) => {
        return (
          <>
            {/* Edit Button with Tooltip */}
            {!record?.soft_delete && (
              <Tooltip
                title={
                  !voyage_status ? "Editing is disabled when voyage status is inactive." : "Edit"
                }
              >
                <span>
                  <Button
                    disabled={!voyage_status}
                    type="primary"
                    size="small"
                    onClick={() => navigate(`/edit-daily-ship-staff-task/${btoa(record?.id)}`)}
                    style={{ marginRight: "15px" }}
                    icon={<EditOutlined />}
                  />
                </span>
              </Tooltip>
            )}

            {/* Delete Button with Confirmation */}
            {!record?.soft_delete && (
              <Popconfirm
                title="Delete Daily Ship Staff Task Record"
                description="Are you sure you want to delete this Daily Ship Staff Task Record? This action cannot be undone."
                onConfirm={() => onDailyShipStaffTaskRecord(record?.id)}
                okText="Yes"
                cancelText="No"
              >
                <Tooltip title="Delete">
                  <Button type="primary" size="small" icon={<DeleteOutlined />} />
                </Tooltip>
              </Popconfirm>
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <VoyageDetails
        staff_dashboard={staff_dashboard?.voyage_details}
        buttonShow={true}
        disabled={!voyage_status}
        buttonProps={{
          text: "Add Logs",
          className: "save_btn",
          onClick: () => navigate("/add-daily-ship-staff-task"),
          onPress: () => navigate("/audit-trail-daily"),
        }}
      />
      <div className="row">
        <div className="col-3" style={{ marginBottom: "13px", marginLeft: "15px" }}>
          <label className="block-label">Select Voyage Id</label>
          <Select
            placeholder="---- Select Voyage Id ----"
            style={{ width: "100%" }}
            value={voyage_ids}
            onChange={(value) => {
              const selectedVoyage = voyageList.find((voyage) => voyage.id === value);
              if (selectedVoyage) {
                set_voyage_status(selectedVoyage.voyage_status);
              }
              set_voyage_id(value);
              LIST_DAILY_SHIP_STAFF_TASK_API(value);
            }}
          >
            {voyageList?.map((voyage) => (
              <Select.Option key={voyage.id} value={voyage.id}>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span>{`Voyage Id: ${voyage.id}`}</span>
                  <span
                    style={{
                      color: voyage.voyage_status === true ? "#FFA500" : "#008000",
                      fontWeight: "550",
                      marginRight: "15px",
                    }}
                  >
                    {voyage.voyage_status === true ? "Running" : "Complete"}
                  </span>
                </div>
              </Select.Option>
            ))}
          </Select>
        </div>

        <div className="col-3" style={{ marginBottom: "13px" }}>
          <label className="block-label">Search</label>
          <Input 
            placeholder="Search by task, dept, role..." 
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            style={{ width: "100%" }}
            allowClear
          />
        </div>
        
        <div className="col-5" style={{ display: "flex", justifyContent: "flex-end" }}>
          <div style={{ marginRight: "15px" }}>
            <label className="block-label">Select Start Date & End Date</label>
            <RangePicker
              presets={dateRanges}
              value={dates}
              onChange={setDates}
              format="YYYY-MM-DD"
              style={{ width: 350 }}
              disabledDate={(current) => current && current > dayjs().endOf("day")}
            />
          </div>
          <div style={{ alignSelf: "flex-end" }}>
            <Button
              type="primary"
              className="save_btn"
              style={{ color: "white", marginBottom: "13px" }}
              onClick={() =>
                DOWNLOADPDF(dailytasklogdownloadPdfUrl, voyage_ids, startDate, endDate)
              }
            >
              Download Pdf
            </Button>
          </div>
        </div>
      </div>

      <Table
        bordered
        loading={page_loader}
        columns={columns}
        dataSource={displayedData}
        pagination={{ pageSize: 10 }}
        rowKey="id"
        className="custom-table"
      />
    </>
  );
};

export default ListDailyShipStaffTask;
